import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { provideNgxMask } from 'ngx-mask';
import { DurationService } from '@shared/ui-components/components/duration/duration.service';
import { CULTURE_SERVICE } from '@shared/reactive-controls/models/iculture-service.model';
import { DefaultCultureService } from '@shared/reactive-controls/services/default-culture.service';
import { HtmlSanitizer } from '@shared/reactive-controls/services/html-sanitizer.service';

/**
 * Root-level providers relocated from the shared/* aggregator modules
 * (ui-components, reactive-controls, utils) so those modules
 * can become pure, provider-free aggregators and eventually be removed.
 */
export function provideSharedServices(): EnvironmentProviders {
  return makeEnvironmentProviders([
    DurationService,
    HtmlSanitizer,
    { provide: CULTURE_SERVICE, useClass: DefaultCultureService },
    provideNgxMask(),
  ]);
}
